import { limitOrderApiConnector } from 'apiConnector/secondary-market/limit-order/order';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, mergeMap, takeUntil } from 'rxjs/operators';
import { limitOrderThunks } from 'state/secondaryMarket/limit-order/limitOrder.thunk';
import type { EpicWithThunk } from 'state/state.common';
import type { HttpError } from 'utils/http/httpClient.model';

import { getTabRemoved$ } from '../utils';

export function amendLimitOrderTradeEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient, frontLogger }) => {
    const { amendOrder } = limitOrderApiConnector(httpClient);

    return actions$.pipe(
      ofType('SECONDARY_MARKET_LIMIT_ORDER_AMEND_REQUESTED'),
      mergeMap(({ tabId, etag, request }) => {
        return amendOrder(etag, request).pipe(
          takeUntil(getTabRemoved$(actions$, tabId)),
          mergeMap(response => of(limitOrderThunks.amendReceivedThunk(tabId, response))),
          catchError((error: HttpError) => {
            frontLogger.error('An error occurred inside amendOrderEpic {@FrontError}', error);
            return of(limitOrderThunks.amendFailedThunk(tabId, error));
          }),
        );
      }),
    );
  };
}
